import Vue from 'vue'
import App from './App.vue'
import router from './router'
 
import store from './store'

import './registerServiceWorker'
import vuetify from './plugins/vuetify';



import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
Vue.http.options.credentials = true;
Vue.http.options.xhr = {
	withCredentials: true
};
Vue.http.options.crossOrigin = true

Vue.http.headers.common['Content-Type'] = 'application/json'
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.http.headers.common['Accept'] = 'application/json, text/plain, */*'
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

const moment = require('moment')
require('moment/locale/tr')
Vue.use(require('vue-moment'), {
	moment
})


Vue.config.productionTip = false

new Vue({
  router,

  store,

  vuetify,
  render: h => h(App)
}).$mount('#app')



String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};
String.prototype.seoUrl = function() {
    var link = this;
    var trMap = {
        'çÇ':'c',
        'ğĞ':'g',
        'şŞ':'s',
        'üÜ':'u',
        'ıİ':'i',
        'öÖ':'o'
    }; 
    for(var key in trMap) {
        link = link.replace(new RegExp('['+key+']','g'), trMap[key]);
    }
    return  link.replace(/[^-a-zA-Z0-9\s]+/ig, '')
                .replace(/\s/gi, "-")
                .replace(/[-]+/gi, "-")
                .toLowerCase();
};